export default "assets/lines-light-mobile-bee8c413.svg";